"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyWebChatButtonWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var React = require("react");
var StickyWebChatButtonWidget = exports.StickyWebChatButtonWidget = /** @class */ (function (_super) {
    __extends(StickyWebChatButtonWidget, _super);
    function StickyWebChatButtonWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadWebChatScript = function () {
            var product = _this.getSetting("product");
            if (product) {
                var scriptPath = "/web-chat-script-".concat(product, ".js");
                // Check if the script is already loaded
                if (!document.querySelector("script[src=\"".concat(scriptPath, "\"]"))) {
                    _this.genesysScript = document.createElement("script");
                    _this.genesysScript.src = scriptPath;
                    _this.genesysScript.async = true;
                    _this.genesysScript.onload = function () {
                        if (typeof window.Genesys === "function") {
                            window.Genesys("init");
                        }
                        else {
                            console.error("Genesys is not defined in the local script.");
                        }
                    };
                    document.head.appendChild(_this.genesysScript);
                }
            }
            else {
                console.log("Web-chat script not available");
            }
        };
        _this.handleBackNavigation = function (event) {
            // Reload the entire page
            if (window.location.href.includes("/products")) {
                window.location.reload();
            }
        };
        return _this;
    }
    StickyWebChatButtonWidget.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('popstate', function (ev) { return _this.handleBackNavigation(ev); });
        this.loadWebChatScript();
    };
    StickyWebChatButtonWidget.prototype.componentWillUnmount = function () {
        var _this = this;
        window.removeEventListener('popstate', function (ev) { return _this.handleBackNavigation(ev); });
    };
    StickyWebChatButtonWidget.prototype.render = function () {
        return React.createElement(React.Fragment, null);
    };
    StickyWebChatButtonWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "product", type: journey_model_1.TypeDescriptions.String }
        ])
    ], StickyWebChatButtonWidget);
    return StickyWebChatButtonWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=StickyWebChatButtonWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/StickyWebChatButtonWidget.js
// module id = 3675
// module chunks = 0